"use client";

import PAText from "component/design-system/typography/PAText/PAText";
import { POPULAR_MANUFACTURE } from "modules/site-structure/accessories-make/manufacture-constant";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { removeDuplicates } from "../../util/lodash/removeDuplicates";
import { PAGE_TYPES } from "../../util/product/product-constants";
import PageContainer from "../components/PageContainer";
import { POPULAR_MAKES } from "./accessories-make/constant";
import AccessoriesMake from "./all-makes/AllMakes";
import AllManufacturers from "./all-manufacturers/AllManufacturers";
import styles from "./allMakeManufacture.module.scss";
const ManufactureItem = dynamic(() => import(/* webpackChunkName: "manufacture-item" */ "component/design-system/ManufactureItem"));
const MakeItem = dynamic(() => import(/* webpackChunkName: "make-item" */ "modules/site-structure/accessories-make/MakeItem"));

function AllMakeManufacture(props: any) {
  const {
    pageType, actualResponse,
  } = props;
  const { t } = useTranslation("common");
  let h1;
  let h2;
  let modelsWithUrl;
  let key;
  let renderChildren;
  let title;

  const router = useRouter();
  const { query } = router;
  const { pathname } = query;

  switch (pageType) {
  case PAGE_TYPES.ALL_MAKES_PAGE:
    modelsWithUrl = removeDuplicates([...POPULAR_MAKES, ...actualResponse.makeWithUrls], "url");
    h1 = (
      <PAText style={{ fontSize: "calc(2.5 * var(--safari-root-font, 10px))" }} inlineBlock className={styles.all_make_h1}>
        {`${t("Search Parts by")} `}
        <PAText style={{ fontSize: "calc(2.5 * var(--safari-root-font, 10px))" }} inlineBlock color="success-secondary">{"VEHICLE MAKERS "}</PAText>
      </PAText>
    );
    h2 = "";
    key = "make";
    renderChildren = MakeItem;
    title = "Search Parts by VEHICLE MAKERS";
    break;
  case PAGE_TYPES.ALL_MANUFACTURERS_PAGE:
    modelsWithUrl = removeDuplicates([...POPULAR_MANUFACTURE, ...actualResponse.manufacturersWithUrls], "url");
    h1 = "Our Manufacturers";
    h2 = "Browse By Manufacturer";
    key = "";
    renderChildren = ManufactureItem;
    title = "Our Manufacturers";
    break;
  default:
    modelsWithUrl = [];
    h1 = "";
    h2 = "";
    title = "";
  }

  return (
    <PageContainer>

      <Head>
        <title>{`PartsAvatar.ca: ${title}`}</title>

        <meta name="description" content={h2} />
        <link rel="canonical" href={`https://partsavatar.ca/${pathname}`} />
      </Head>

      <HideIf show={pageType === PAGE_TYPES.ALL_MANUFACTURERS_PAGE}>
        <AllManufacturers
          labelKey={key}
          renderChildren={renderChildren}
          modelsWithUrl={modelsWithUrl}
          h1={h1}
          h2={h2}
        />

      </HideIf>
      <HideIf show={pageType === PAGE_TYPES.ALL_MAKES_PAGE}>
        <AccessoriesMake
          labelKey={key}
          renderChildren={renderChildren}
          modelsWithUrl={modelsWithUrl}
          h1={h1}
          h2={h2}
        />
      </HideIf>
    </PageContainer>
  );
}

export default AllMakeManufacture;
